export const QUEUE_COMMAND = 'QUEUE_COMMAND';
export const CLEAR_QUEUED_COMMAND = 'CLEAR_QUEUED_COMMAND';